var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEventAvailable(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 26,
    viewBox: "0 0 24 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.6844 20.9375L6.24831 16.5L8.06025 14.6875L10.6844 17.3125L15.9328 12.0625L17.7448 13.875L10.6844 20.9375ZM3.24923 25.5C2.56194 25.5 1.97358 25.2552 1.48415 24.7656C0.994716 24.276 0.75 23.6875 0.75 23V5.5C0.75 4.8125 0.994716 4.22396 1.48415 3.73438C1.97358 3.24479 2.56194 3 3.24923 3H4.49885V0.5H6.99808V3H16.995V0.5H19.4942V3H20.7438C21.4311 3 22.0195 3.24479 22.5089 3.73438C22.9984 4.22396 23.2431 4.8125 23.2431 5.5V23C23.2431 23.6875 22.9984 24.276 22.5089 24.7656C22.0195 25.2552 21.4311 25.5 20.7438 25.5H3.24923ZM3.24923 23H20.7438V10.5H3.24923V23ZM3.24923 8H20.7438V5.5H3.24923V8Z",
    fill: "#515253"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEventAvailable);
export default __webpack_public_path__ + "static/media/event_available.9512bfb148c9be30453307f6f0c27a46.svg";
export { ForwardRef as ReactComponent };